import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeService from './Employee.service';

export const getEmployeeListThunk = createAsyncThunk(
  'employee/getEmployeeListThunk',
  async ({ group, search, page, ids }: any, thunkAPI) => {
    const response = await employeeService.getList({
      group,
      search,
      page,
      ids,
    });
    return response.data;
  },
);
